module.exports = __webpack_public_path__ + "img/lqsxback_4.7d7e5075.svg";